import { ALTERAR_REGISTROS_POR_PAGINA_ROTA } from '../types'

export default function alterarRegistrosPorPaginaRotas (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_ROTA,
    payload: valor
  }
}
